// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/dietz-jubilarfeier-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const dietzJubilarfeier22DE: PageEntry = {
  id: "post.dietz-jubilarfeier-2-2",
  locale: "de",
  slug: "dietz-jubilarfeier-2-2",
  seo: {
    title: "Sponsored by Dietz GmbH - Jonas Jannusch holt Bronze im Bob | Dietz GmbH",
    description: "Sponsored by Dietz GmbH - Jonas Jannusch holt Bronze im Bob",
  },
  type: "post",
  h1: "Sponsored by Dietz GmbH - Jonas Jannusch holt Bronze im Bob",
  blocks: [
    { kind: "heading", level: 2, text: "Sponsored by Dietz GmbH – Jonas Jannusch holt Bronze im Bob" }
  ],
};
